<template lang="pug">
  .sud-card-title
    slot
</template>

<script>
export default {
  name: 'app-card-title'
}
</script>

<style scoped>
.sud-card-title {
  margin-bottom: 11px;
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  color: #314369;
  word-break: break-word !important;
}
</style>